import { useAppState } from 'src/state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function OperationsAdminVenueAreaBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().areas
    if (!currentItem) return <span>Area</span>;
    return (
        <span>{`${currentItem.name}`}</span>
    );
}